import { render, staticRenderFns } from "./LedDetails.vue?vue&type=template&id=1fb1a9f4&"
import script from "./LedDetails.vue?vue&type=script&lang=js&"
export * from "./LedDetails.vue?vue&type=script&lang=js&"
import style0 from "./LedDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports